export const columns = [{
    name: 'Name',
    key: 'AGENT_NAME',
},
{
    name: 'Courting',
    key: 'hsc_courting_count',
    class: 'Pipeline_column_numeric',
},
{
    name: 'Hot List',
    subColumns: [{
        name: 'Properties',
        key: 'hsc_properties_count',
        class: 'Pipeline_column_numeric',
    },{
        name: 'Agents',
        key: 'hsc_agents',
        class: 'Pipeline_column_numeric',
    }, {
        name: 'Investors',
        key: 'hsc_buyers',
        class: 'Pipeline_column_numeric',
    }]
}, 
{
    name: 'Follow Up',
    key: 'hsc_follow_up_count',
    class: 'Pipeline_column_numeric',
}
];

